import { portalAPI } from './portalAPI';

export type EditableResourceType = 'CORRESPONDENCE' | 'INVOICE' | 'CASE';

export interface EditorDto {
    employeeId: number;
    firstName: string;
    lastName: string;
    fullName: string;
}

interface HeartbeatResponseDto {
    success: boolean;
    otherEditors: EditorDto[];
}

interface ResourceIdentifier {
    resourceType: EditableResourceType;
    resourceId: string | number;
}

const APIEditingSessionSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        sendEditingHeartbeat: builder.mutation<HeartbeatResponseDto, ResourceIdentifier>({
            query: ({ resourceType, resourceId }) => ({
                url: `/v1/editing-session/${resourceType}/${resourceId}/heartbeat`,
                method: 'POST',
            }),
            extraOptions: { skipButtonDisable: true },
        }),
        endEditingSession: builder.mutation<void, ResourceIdentifier>({
            query: ({ resourceType, resourceId }) => ({
                url: `/v1/editing-session/${resourceType}/${resourceId}`,
                method: 'DELETE',
            }),
            extraOptions: { skipButtonDisable: true },
        }),
    }),
});

export const { useSendEditingHeartbeatMutation, useEndEditingSessionMutation } = APIEditingSessionSlice;
